export default "/assets/images/technology-graph-02.svg?14f77e4a79796b45f714c5c7ea6707e4";